const CustomTooltip = (props) => {
    // Użyj \n do podzielenia tekstu na akapity
    const tooltipLines = props.value.split('\n'); // Podziel tekst na linie
  
    return (
      <div className="custom-tooltip">
        {tooltipLines.map((line, index) => (
          <p key={index} style={{ margin: '5px' }}>
            {line}
          </p>
        ))}
      </div>
    );
  };
  
  export default CustomTooltip;